<template>
  <div class="PasswordLogin">
    <MyTab v-if="step_2.length !== 0"></MyTab>
    <!-- 信息认证 -->
    <TabInfoAuthentication
      v-show="tabActive === 1"
      :configList="step_1"
      :perfectOrderInfo="perfectOrderInfo"
      :bankName="bankName"
    />
    <!-- 资料填写 -->
    <TabSupplementInfo
      v-show="tabActive === 2"
      :configList="step_2"
      :perfectOrderInfo="perfectOrderInfo"
    />
    <!-- 弹框 -->
    <Notification
      :isShow="isShowNotif"
      :title="title"
      :activeIndex="activeIndex"
    ></Notification>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Notification from './components/common/Notification.vue';
import TabSupplementInfo from './components/tabSupplementInfo/index.vue';
import TabInfoAuthentication from './components/tabInfoAuthentication/index.vue';
import MyTab from './components/common/MyTab.vue';
import { enhanceXydContractConfig } from '@/utils/xydNoTax';

export default {
  name: 'Perfect',
  data() {
    return {
      title: '',
      isShowNotif: false,
      step_1: [], // 第一个tab页面的配置
      step_2: [], // 第二个tab页面的配置
      perfectOrderInfo: {}, // 回显的数据
      bankName: '',
      activeIndex:''
    };
  },
  components: {
    MyTab,
    Notification,
    TabSupplementInfo,
    TabInfoAuthentication,
  },
  created() {
    // 获取用户信息
    this.getUserInfo();
    // 获取页面配置和回显数据
    this.getProductionConfig();
    // 获取该产品所属服务银行名称
    this.getBankNameByProduct();
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
    ...mapState({
      tabActive(val) {
        return val.publicPage.tabActive;
      },
    }),
  },
  // 根据认证状态判断是否有在途订单
  watch: {
    // 监听store里在途状态
    'publicPage.personAuthStatus': {
      handler(val) {
        if (val === true) {
          this.isShow = false;
          this.getUnfinishedOrder();
        } else if (val === false) {
          this.isShow = true;
        }
      },
      deep: true,
      immediate: true,
    },
    // 修改标题
    tabActive: {
      handler(n) {
        if (this.step_2.length === 0) {
          document.title = '信息认证';
          return;
        }
        if (n === 1) {
          document.title = '信息认证';
        } else {
          document.title = '资料填写';
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),
    // 是否有在途订单，是的话提示弹框
    getUnfinishedOrder() {
      this.$api.PublicPage.getUnfinishedOrder({
        productId: this.$route.query.productId,
      })
        .then((res) => {
          if (res.success) {
            if (res.data.show) {
              this.isShowNotif = true;
              this.title = '当前您有未完成的申请';
              this.activeIndex = res.data.activeIndex
            }
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },

    // 获取配置项进件
    getProductionConfig() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        productId: this.$route.query.productId,
      })
        .then((res) => {
          if (res.success) {
            const result = JSON.parse(res.data[0].productConfigs);
            // eslint-disable-next-line camelcase
            const t1 = result[0].step_1.find((e) => e.type === 'Contract');
            t1 && (t1.props.isForceRead = true) && (t1.props.counts = 3);
            // t1.props.list[0].value = 'YiLianKKAuth' // 临时查看协议
            // let t2 = result[0].step_2.find((e) => {
            //   return e.type === "Contract"
            // })
            // t2 && (t2.props.isForceRead = true);
            const step_1 = result[0].step_1 || [];
            // eslint-disable-next-line camelcase
			      const step_2 = result[0].step_2 || [];
            // 给字段增加函数校验
            const Index = step_1.findIndex((e) => e.type === 'SelectInputs');
            const Index2 = step_2.findIndex((e) => e.type === 'SelectInputs');
            const haierIndex = step_1.some((e) => e.isShow === true);
            this.updateState({
              haierIndex,
            });
            if (Index === -1 && Index2 === -1) {
              this.updateState({
                isShowCorpName: true,
              });
            }
            this.step_1 = step_1.map((item, index) => {
              item = enhanceXydContractConfig(item, this.$route.query.productId);
              if (item.type === 'Contract'|| item.type === 'ContractFold') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'ApplicationType') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      const flag = value * 1 <= 2;
                      return !!flag;
                    },
                  },
                  ],
                };
              }
              return item;
            });
            this.step_2 = step_2.map((item) => {
              if (item.type === 'Contract'|| item.type === 'ContractFold') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'LoanAmountInput') {
                return {
                  ...item,
                  validate: [
                    {
                      validator(rule, value) {
                        if (Number(value) >= Number(item.props.min) && Number(value) <= Number(item.props.max)) {
                          return true;
                        }
                        return false;
                      },
                      message: `${item.props.min}-${item.props.max}(万元)正整数`,
                    },
                  ],
                };
              }
              if ((this.$route.query.productId === 'YL-YPD' && item.field === 'iceContactPhone')||(this.$route.query.productId === 'BW-BSD' && (item.field === 'iceContactPhone'||item.field === 'iceContactPhone2'))) { // 亿联控制紧急联系人手机号不能与申请人手机号一致
                const applyPhone = sessionStorage.getItem('APPLE_PHONE');
                return {
                  ...item,
                  ...item.validate.push({
                    message: '借款人手机号不能与联系人手机号一致',
                    pattern: [new RegExp(`^(?!${applyPhone})`)],
                  }),
                };
              }
              return item;
            });
          }
          this.getUserCorp();
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    getUserCorp() {
      this.$api.PublicPage.getUserCorp({
        productId: this.$route.query.productId,
        foreignOrderId: this.$route.query.foreignOrderId,
      }).then((res) => {
        if (res.success) {
          const { data } = res;
          sessionStorage.setItem('APPLE_PHONE', data.phone);
          this.perfectOrderInfo = {
            ...res.data,
            borrowerType: data.userType,
            borrowerIdentity: data.identity,
            borrowerPhone: data.phone,
            borrowerName: data.userName,
          };
          this.updateState({
            submitInfoAll: {
              corpId: '', // 默认清空 corpId
              ...this.publicPage.submitInfoAll,
              ...res.data,
            },
          });
        }
        this.historyOrederInfo();
      });
    },
    historyOrederInfo() {
      this.$api.PublicPage.getPerfectOrderInfo(this.$route.query.productId)
        .then((res) => {
          const {
            bizAddressCode,
            bizProvince,
            bizCity,
            bizCounty,
            borrowerProvince,
            borrowerCity,
            borrowerCounty,
            borrowerAddressCode,
          } = res.data;
          const invitationCodeObj = JSON.parse(sessionStorage.getItem('invitationCodeObj'));
          const resData = {
            ...res.data,
          };
          if (invitationCodeObj && !invitationCodeObj.support) { // 解决KA邀请码覆盖问题，如果邀请码不可编辑，就用新查询的邀请码
            resData.referrer = invitationCodeObj.inviteCode;
          }

          this.perfectOrderInfo = {
            ...this.perfectOrderInfo,
            ...resData,
            bizAddressList: bizAddressCode
              ? {
                value: bizAddressCode,
                name: `${bizProvince} ${bizCity} ${bizCounty}`,
              }
              : '',
            borrowerAddressList: borrowerAddressCode
              ? {
                value: borrowerAddressCode,
                name: `${borrowerProvince} ${borrowerCity} ${borrowerCounty}`,
              }
              : '',
          };
          this.updateState({
            submitInfoAll: {
              ...this.perfectOrderInfo,
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取该产品所属服务银行名称
    getBankNameByProduct() {
      this.$api.PublicPage.getBankNameByProduct({
        productId: this.$route.query.productId,
      }).then((res) => {
        this.bankName = res.data.showOrgName;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.PasswordLogin {
  >>> .agreement {
    margin-top: 6px;
  }

}

</style>
